/* Emir ICE — GALERIE DU STUDIO IA (section sections/eix-galerie-studio.liquid), 2026-11-04. Sans dépendance. Préfixe eix-gal.
   1. Lecture : GET <serveur>/api/galerie?n=24&apres=<curseur> → {items: [{img, type, metal, pierre, styles, date}], suite}.
      Adresse du serveur : attribut data-endpoint de la section, sinon celle du Studio présent sur la page ([data-eix-studio] data-config).
      Jamais d'erreur visible : sans adresse, réponse vide ou serveur muet, la page complète montre l'état vide et l'aperçu reste caché.
   2. Grille en maçonnerie : N colonnes (2 sur téléphone, 3 sur tablette, 4 sur ordinateur), chaque image va dans la colonne la plus courte ;
      la page complète charge la suite quand on approche du bas (bouton « Voir plus » en secours).
   3. Visionneuse : toucher une image l'agrandit (Échap, flèches, balayage au doigt, Tab enfermé, retour du focus sur l'image d'origine).
   InstantClick remplace le <body> sans recharger : ce fichier est ré-exécuté, boot() repart du nouveau document ; les écouteurs globaux ne sont posés qu'une fois. */
(function () {
  'use strict';
  if (window.__eixGal) { window.__eixGal.boot(); return; }

  var D = document, W = window;
  var RM = W.matchMedia ? W.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };

  /* mêmes identifiants que le Studio (assets/eix-studio.js) et le serveur */
  var TYPES = { pendentif: 'Pendentif', bague: 'Bague', bracelet: 'Bracelet', chaine: 'Chaîne', boucles: 'Boucles d’oreilles', grillz: 'Grillz' };
  var METAUX = { argent: 'argent 925', 'or-jaune': 'or jaune', 'or-blanc': 'or blanc', 'or-rose': 'or rose' };
  var PIERRES = { moissanite: 'moissanite', laboratoire: 'diamant de laboratoire', naturel: 'diamant naturel', aucune: '', conseil: '' };
  var STYLES = { iced: 'Iced out', minimal: 'Minimaliste', royal: 'Royal', streetwear: 'Streetwear', vintage: 'Vintage', nature: 'Nature', geometrique: 'Géométrique', delicat: 'Délicat' };

  function tous(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function propre(s, max) { return String(s == null ? '' : s).replace(/[\u0000-\u001f<>]/g, ' ').replace(/\s+/g, ' ').trim().slice(0, max || 60); }
  function reduit() { return !!RM.matches; }

  /* libellés lisibles : identifiant connu → texte français, sinon le texte reçu nettoyé */
  function libType(t) { return TYPES[t] || propre(t, 40); }
  function libMetal(m) {
    if (!m) return '';
    if (typeof m === 'object') { var base = METAUX[m.id || m.metal] || propre(m.fr || m.id || '', 30); return base + (m.titre ? ' ' + propre(m.titre, 4) : ''); }
    var s = String(m); var titre = '';
    var k = s.match(/^(.*?)[\s-]*(10K|14K|18K)$/i); if (k) { s = k[1]; titre = ' ' + k[2].toUpperCase(); }
    return (METAUX[s] != null ? METAUX[s] : propre(s, 30)) + titre;
  }
  function libPierre(p) { if (!p) return ''; return PIERRES[p] != null ? PIERRES[p] : propre(p, 40); }
  function libStyles(st) { if (!Array.isArray(st)) return []; return st.slice(0, 3).map(function (x) { return STYLES[x] || propre(x, 24); }).filter(Boolean); }
  function dateFr(iso) {
    if (!iso) return '';
    var d = new Date(iso); if (isNaN(d.getTime())) return '';
    try { return d.toLocaleDateString('fr-FR', { day: 'numeric', month: 'long', year: d.getFullYear() === new Date().getFullYear() ? undefined : 'numeric' }); } catch (e) { return ''; }
  }
  function titreItem(it) {
    var t = libType(it.type) || 'Bijou'; var m = libMetal(it.metal);
    return t + (m ? ' en ' + m : '');
  }
  function altItem(it) {
    var p = libPierre(it.pierre);
    return titreItem(it) + (p ? ', ' + p : '') + ' : création du Studio IA Emir ICE';
  }

  /* adresse du serveur : la section d'abord, puis le Studio de la page */
  function adresse(root) {
    var a = (root.getAttribute('data-endpoint') || '').trim();
    if (!a) {
      var st = D.querySelector('[data-eix-studio]');
      if (st) { try { a = String(JSON.parse(st.getAttribute('data-config') || '{}').endpoint || ''); } catch (e) { a = ''; } }
    }
    a = a.split('?')[0].split('#')[0].replace(/\/+$/, '');
    return /^https:\/\/[a-z0-9.-]+(:\d+)?(\/[\w.\/-]*)?$/i.test(a) ? a : '';
  }
  /* l'image publique : URL https complète, chemin du serveur (/api/g/<jeton>) ou jeton seul */
  function urlImage(base, img) {
    var s = String(img || '').trim(); if (!s) return '';
    if (/^https:\/\//i.test(s)) return s;
    if (s.charAt(0) === '/' && s.charAt(1) !== '/') return base + s;
    if (/^[A-Za-z0-9_-]{6,80}$/.test(s)) return base + '/api/g/' + s;
    return '';
  }

  function lire(url, delai) {
    var ctl = W.AbortController ? new AbortController() : null;
    var t = setTimeout(function () { if (ctl) ctl.abort(); }, delai || 12000);
    return fetch(url, { method: 'GET', mode: 'cors', credentials: 'omit', signal: ctl ? ctl.signal : undefined })
      .then(function (r) { if (!r.ok) throw new Error('http ' + r.status); return r.json(); })
      .then(function (j) { clearTimeout(t); return j; }, function (e) { clearTimeout(t); throw e; });
  }

  /* ====================================================================== une galerie */
  function Galerie(root) {
    var G = this;
    G.root = root;
    G.page = root.getAttribute('data-mode') === 'page';
    G.n = Math.max(1, Math.min(48, parseInt(root.getAttribute('data-n'), 10) || 24));
    G.base = adresse(root);
    G.items = []; G.vus = {}; G.suite = ''; G.charge = false; G.fini = false; G.cols = []; G.nbCols = 0;
    G.grille = root.querySelector('[data-gal-grille]');
    G.vide = root.querySelector('[data-gal-vide]');
    G.btnSuite = root.querySelector('[data-gal-suite]');
    G.sentinelle = root.querySelector('[data-gal-sentinelle]');
    G.studio = root.getAttribute('data-studio') || '/pages/studio';
    G.bouton = root.getAttribute('data-bouton') || 'Créer le mien';

    /* sous le Studio, « Créer le mien » remonte simplement au Studio de la page */
    var st = D.querySelector('[data-eix-studio]');
    if (!G.page && st && st.id) { G.studio = '#' + st.id; tous(root, '[data-gal-creer]').forEach(function (a) { a.setAttribute('href', G.studio); }); }

    root.addEventListener('click', function (e) {
      var b = e.target.closest ? e.target.closest('[data-gal-i]') : null;
      if (b && root.contains(b)) { e.preventDefault(); ouvrir(G, +b.getAttribute('data-gal-i'), b); return; }
      if (e.target.closest && e.target.closest('[data-gal-plus]')) { e.preventDefault(); G.charger(); }
    });

    if (!G.base) { G.termine(); return; }
    G.charger();
    if (G.page && G.sentinelle && W.IntersectionObserver) {
      G.io = new IntersectionObserver(function (ent) { if (ent[0] && ent[0].isIntersecting && !G.charge && !G.fini && G.items.length) G.charger(); }, { rootMargin: '900px 0px' });
      G.io.observe(G.sentinelle);
    }
  }

  Galerie.prototype.charger = function () {
    var G = this; if (G.charge || G.fini || !G.base) return;
    G.charge = true; G.grille.setAttribute('aria-busy', 'true');
    if (G.btnSuite) G.btnSuite.classList.add('is-busy');
    var url = G.base + '/api/galerie?n=' + G.n + (G.suite ? '&apres=' + encodeURIComponent(G.suite) : '');
    lire(url, 12000).then(function (j) {
      var liste = j && Array.isArray(j.items) ? j.items : [];
      var nouveaux = [];
      liste.forEach(function (it) {
        if (!it || typeof it !== 'object') return;
        var src = urlImage(G.base, it.img); if (!src || G.vus[src]) return;
        G.vus[src] = 1;
        var x = { src: src, type: it.type, metal: it.metal, pierre: it.pierre, styles: it.styles, date: it.date };
        G.items.push(x); nouveaux.push(x);
      });
      var s = j && typeof j.suite === 'string' ? j.suite : '';
      G.suite = s && s !== G.suite ? s : '';
      if (!G.page || !G.suite || !nouveaux.length) G.fini = true;
      /* la grille doit être visible avant d'y placer les images : la colonne la plus courte se mesure à l'écran */
      if (nouveaux.length) { if (!G.page) G.root.hidden = false; G.grille.hidden = false; G.ajouter(nouveaux); }
      G.charge = false; G.termine();
    }, function () {
      /* serveur muet : on n'affiche rien de plus ; s'il y a déjà des images, le bouton « Voir plus » permet de réessayer */
      G.charge = false;
      if (!G.items.length) G.fini = true;
      G.termine(true);
    });
  };

  /* état visible après chaque chargement */
  Galerie.prototype.termine = function (echec) {
    var G = this; var a = G.items.length > 0;
    G.grille.setAttribute('aria-busy', 'false');
    var sq = G.grille.querySelector('[data-gal-sq]'); if (sq && (a || G.fini || echec)) sq.parentNode.removeChild(sq);
    if (G.page) {
      if (G.vide) G.vide.hidden = a;
      G.grille.hidden = !a;
      if (G.btnSuite) { G.btnSuite.hidden = !(a && (!G.fini || echec) && (G.suite || echec)); G.btnSuite.classList.remove('is-busy'); }
      if (G.fini && G.io) { G.io.disconnect(); G.io = null; }
    } else {
      G.root.hidden = !a;
    }
  };

  Galerie.prototype.nbColonnes = function () {
    var w = this.grille.clientWidth || W.innerWidth;
    return w < 560 ? 2 : (w < 900 ? 3 : 4);
  };
  Galerie.prototype.colonnes = function () {
    var G = this; var n = G.nbColonnes();
    if (n === G.nbCols && G.cols.length) return false;
    G.nbCols = n; G.grille.innerHTML = ''; G.cols = [];
    for (var i = 0; i < n; i++) { var c = D.createElement('div'); c.className = 'eix-gal-col'; G.grille.appendChild(c); G.cols.push(c); }
    G.grille.style.setProperty('--cols', String(n));
    return true;
  };
  Galerie.prototype.tuile = function (x, i, anime) {
    var styles = libStyles(x.styles); var p = libPierre(x.pierre);
    var f = D.createElement('figure');
    f.className = 'eix-gal-it' + (anime && !reduit() ? ' is-new' : '');
    if (anime) f.style.setProperty('--d', ((i % 12) * 55) + 'ms');
    f.innerHTML = '<button type="button" class="eix-gal-it__b" data-gal-i="' + i + '">' +
      '<img src="' + esc(x.src) + '" alt="' + esc(altItem(x)) + '" width="1024" height="1024" loading="lazy" decoding="async" draggable="false">' +
      '<span class="eix-gal-it__z" aria-hidden="true"><svg viewBox="0 0 24 24"><circle cx="10.5" cy="10.5" r="6"/><path d="M15 15l5 5M10.5 8v5M8 10.5h5"/></svg></span></button>' +
      '<figcaption class="eix-gal-it__c"><b>' + esc(titreItem(x)) + '</b>' + (p || styles.length ? '<span>' + esc([p].concat(styles).filter(Boolean).join(' · ')) + '</span>' : '') + '</figcaption>';
    var img = f.querySelector('img');
    /* une image refusée par le navigateur (supprimée entre-temps) disparaît sans laisser de trou */
    img.addEventListener('error', function () { f.classList.add('is-ko'); });
    img.addEventListener('load', function () { if (img.naturalWidth && img.naturalHeight) img.style.aspectRatio = img.naturalWidth + ' / ' + img.naturalHeight; f.classList.add('is-ok'); });
    return f;
  };
  Galerie.prototype.placer = function (f) {
    var G = this; var best = G.cols[0]; var h = Infinity;
    for (var i = 0; i < G.cols.length; i++) { var oh = G.cols[i].offsetHeight; if (oh < h - 1) { h = oh; best = G.cols[i]; } }
    best.appendChild(f);
  };
  Galerie.prototype.ajouter = function (nouveaux) {
    var G = this;
    if (G.colonnes()) { G.items.forEach(function (x, i) { if (nouveaux.indexOf(x) < 0) G.placer(G.tuile(x, i, false)); }); }
    nouveaux.forEach(function (x) { G.placer(G.tuile(x, G.items.indexOf(x), true)); });
  };
  Galerie.prototype.redisposer = function () {
    var G = this; if (!G.items.length || G.nbColonnes() === G.nbCols) return;
    G.colonnes(); G.items.forEach(function (x, i) { G.placer(G.tuile(x, i, false)); });
  };

  /* ====================================================================== visionneuse (une seule, partagée par les galeries de la page) */
  var LB = { el: null, g: null, i: 0, retour: null, x0: null };
  function creerLB() {
    var el = D.createElement('div');
    el.className = 'eix-gal-lb'; el.hidden = true;
    el.setAttribute('role', 'dialog'); el.setAttribute('aria-modal', 'true'); el.setAttribute('aria-labelledby', 'eix-gal-lb-t');
    el.innerHTML = '<div class="eix-gal-lb__fond" data-lb="fermer"></div>' +
      '<div class="eix-gal-lb__in">' +
        '<button type="button" class="eix-gal-lb__x" data-lb="fermer" aria-label="Fermer"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg></button>' +
        '<figure class="eix-gal-lb__fig"><div class="eix-gal-lb__img"><img alt="" data-lb-img draggable="false"></div>' +
        '<figcaption class="eix-gal-lb__c"><p class="eix-gal-lb__k" data-lb-n></p><p class="eix-gal-lb__t" id="eix-gal-lb-t" data-lb-t></p><p class="eix-gal-lb__d" data-lb-d></p>' +
        '<a class="eix-gal-btn eix-gal-btn--or" data-lb-creer href="/pages/studio"><span></span><svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M5 12h14M13 6l6 6-6 6"/></svg></a></figcaption></figure>' +
        '<button type="button" class="eix-gal-lb__nav eix-gal-lb__nav--p" data-lb="prec" aria-label="Création précédente"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M15 5l-7 7 7 7"/></svg></button>' +
        '<button type="button" class="eix-gal-lb__nav eix-gal-lb__nav--s" data-lb="suiv" aria-label="Création suivante"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 5l7 7-7 7"/></svg></button>' +
      '</div>';
    D.body.appendChild(el);
    el.addEventListener('click', function (e) {
      var a = e.target.closest ? e.target.closest('[data-lb]') : null;
      if (a) { var q = a.getAttribute('data-lb'); if (q === 'fermer') fermer(); else montrer(LB.i + (q === 'suiv' ? 1 : -1)); return; }
      if (e.target.closest && e.target.closest('[data-lb-creer]')) fermer(true);
    });
    el.addEventListener('pointerdown', function (e) { if (e.pointerType !== 'mouse') LB.x0 = { x: e.clientX, y: e.clientY }; });
    el.addEventListener('pointerup', function (e) {
      if (!LB.x0) return; var dx = e.clientX - LB.x0.x, dy = e.clientY - LB.x0.y; LB.x0 = null;
      if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.4) montrer(LB.i + (dx < 0 ? 1 : -1));
    });
    el.addEventListener('pointercancel', function () { LB.x0 = null; });
    return el;
  }
  function ouvrir(g, i, depuis) {
    if (!LB.el || !D.body.contains(LB.el)) LB.el = creerLB();
    LB.g = g; LB.retour = depuis || D.activeElement;
    var cr = LB.el.querySelector('[data-lb-creer]');
    cr.setAttribute('href', g.studio); cr.querySelector('span').textContent = g.bouton;
    montrer(i);
    LB.el.hidden = false;
    D.documentElement.classList.add('eix-gal-ouvert');
    if (!reduit()) { LB.el.classList.remove('is-in'); void LB.el.offsetWidth; LB.el.classList.add('is-in'); }
    var x = LB.el.querySelector('.eix-gal-lb__x'); if (x) x.focus({ preventScroll: true });
  }
  function montrer(i) {
    var g = LB.g; if (!g || !g.items.length) return;
    var n = g.items.length; i = ((i % n) + n) % n; LB.i = i;
    var x = g.items[i]; var el = LB.el;
    var img = el.querySelector('[data-lb-img]');
    img.src = x.src; img.alt = altItem(x);
    el.querySelector('[data-lb-n]').textContent = 'Création ' + (i + 1) + ' sur ' + n + (g.fini ? '' : '+');
    el.querySelector('[data-lb-t]').textContent = titreItem(x);
    var p = libPierre(x.pierre); var st = libStyles(x.styles); var dt = dateFr(x.date);
    el.querySelector('[data-lb-d]').textContent = [p ? p.charAt(0).toUpperCase() + p.slice(1) : '', st.join(', '), dt ? 'créé le ' + dt : ''].filter(Boolean).join(' · ');
    tous(el, '.eix-gal-lb__nav').forEach(function (b) { b.hidden = n < 2; });
    /* en arrivant au bout de ce qui est chargé, la page complète va chercher la suite */
    if (g.page && !g.fini && i >= n - 3) g.charger();
  }
  function fermer(sansRetour) {
    if (!LB.el || LB.el.hidden) return;
    LB.el.hidden = true; LB.el.classList.remove('is-in');
    D.documentElement.classList.remove('eix-gal-ouvert');
    var r = LB.retour; LB.retour = null; LB.g = null;
    if (!sansRetour && r && r.focus && D.body.contains(r)) { try { r.focus({ preventScroll: true }); } catch (e) { r.focus(); } }
  }
  function clavier(e) {
    if (!LB.el || LB.el.hidden) return;
    if (e.key === 'Escape') { e.preventDefault(); fermer(); }
    else if (e.key === 'ArrowRight') { e.preventDefault(); montrer(LB.i + 1); }
    else if (e.key === 'ArrowLeft') { e.preventDefault(); montrer(LB.i - 1); }
    else if (e.key === 'Tab') {
      var f = tous(LB.el, 'button:not([hidden]), a[href]').filter(function (x) { return x.offsetParent !== null; });
      if (!f.length) return;
      var premier = f[0], dernier = f[f.length - 1];
      if (e.shiftKey && D.activeElement === premier) { e.preventDefault(); dernier.focus(); }
      else if (!e.shiftKey && D.activeElement === dernier) { e.preventDefault(); premier.focus(); }
    }
  }

  /* ====================================================================== démarrage */
  var GALS = [];
  function boot() {
    fermer(true); LB.el = null;
    GALS = GALS.filter(function (g) { return D.body.contains(g.root); });
    tous(D, '[data-eix-gal]').forEach(function (r) { if (!r.__eixGal) { r.__eixGal = true; GALS.push(new Galerie(r)); } });
  }
  var rT = 0;
  W.addEventListener('resize', function () { clearTimeout(rT); rT = setTimeout(function () { GALS.forEach(function (g) { g.redisposer(); }); }, 160); });
  D.addEventListener('keydown', clavier);

  W.__eixGal = { boot: boot };
  if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', boot); else boot();
})();
